module.exports = __webpack_public_path__ + "static/img/official_account_dingyue.704394a4.jpg";